var config = {
    // host: 'http://localhost/manage/api',
    // webImg: 'http://localhost/manage'
    // host:'http://web.guotone.com/manage/api',
    // webImg:'http://web.guotone.com/manage'
    // host:'http://guojigw.hefeiapp.cn/manage/api',
    // webImg:'http://guojigw.hefeiapp.cn/manage'

}
let port = ""
if ('116.62.66.74' == location.hostname) {
    port = ":9208"
}

// 本地连接线上调试
// config.host = 'http:' + '//' + 'hefeitongan.hfrjkf.cn'  + '/manage/api'
// config.webImg = 'http:' + '//' + 'hefeitongan.hfrjkf.cn' + '/manage'

// 本地前后端调试
// config.host = location.protocol + '//' + 'localhost:9208'  + '/manage/api'
// config.webImg = location.protocol + '//' + 'localhost:9208' + '/manage'

// 打包发布
config.host = location.protocol + '//' + location.hostname  + '/manage/api'
config.webImg = location.protocol + '//' + location.hostname + '/manage'
console.log(config);
export default config




// WEBPACK FOOTER //
// ./src/utils/config.js